/** @jsxImportSource @emotion/react */

import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import { State as ViewStateType } from "../components/ViewState";
import { useAuth } from "../context/auth";
import tokenParser from "../utils/tokenParser";

import { authFetcher } from "./useAuthSWR";

interface Player {
  state: ViewStateType;
  token: string;
}

interface Return {
  player: Player;
  pollToken?: string;
  getPlayerToken: () => void;
}

const usePlayerToken = (): Return => {
  const { logout } = useAuth();
  const { id } = useParams<{ id: string }>();

  const [player, setPlayer] = useState<Player>({ state: "loading", token: "" });
  const [pollToken, setPollToken] = useState<string>();

  const getPlayerToken = async (): Promise<void> => {
    try {
      const { data } = await authFetcher(`/live-events/${id}/player-token`, {
        method: "post",
        logout,
      });

      setPlayer({ state: "success", token: data.access_token });
      const parsedToken = tokenParser(data.access_token);
      setPollToken(parsedToken?.pollToken);
    } catch (error: any) {
      console.error("> Control room detail > getPlayerToken: ", error);
      // TODO: need to pair error code with status code for correct error handling (ref: https://docs.blendvision.io/moment/api/cms/#overview--error-codes)
      setPlayer({ ...player, state: error.code || error.status || "error" });
    }
  };

  useEffect(() => {
    if (id) {
      getPlayerToken();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return {
    player,
    pollToken,
    getPlayerToken,
  };
};

export default usePlayerToken;
